/** Static 3-up explainer cards — provider-neutral guidance, sponsor clearly labelled. */

export function Explainers() {
  return (
    <div data-rt-3col="" style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, paddingTop: 40 }}>
      <div data-rt-card="" style={cardStyle}>
        <span style={titleStyle}>Why leaks happen</span>
        <p style={pStyle}>DNS settings live in several places at once — your router, your OS, your browser, individual apps. When they disagree, some queries quietly take their own route.</p>
        <p style={pStyle}>Misconfiguration causes most leaks. Networks that deliberately intercept DNS cause the rest.</p>
      </div>
      <div data-rt-card="" style={{ ...cardStyle, gap: 12 }}>
        <span style={titleStyle}>Fix it in two minutes</span>
        {[
          <>On a VPN, turn on its <span style={{ color: "#DEDFDF" }}>DNS leak protection</span> (often called “block outside DNS” or a kill switch).</>,
          <>Set your OS DNS to <span style={{ color: "#DEDFDF" }}>automatic</span> so the VPN decides — or, without a VPN, pick an encrypted public resolver such as <a href="https://www.quad9.net/" target="_blank" rel="noopener noreferrer">Quad9</a> or <a href="https://one.one.one.one/dns/" target="_blank" rel="noopener noreferrer">Cloudflare DNS</a>.</>,
          <>Rerun this test. Every answer should come from a resolver you chose.</>,
        ].map((body, i) => (
          <div key={i} style={{ display: "flex", gap: 12, alignItems: "baseline" }}>
            <span style={{ fontFamily: "'Sora', sans-serif", fontWeight: 800, fontSize: 15, color: "#DCF300", flex: "none" }}>{i + 1}</span>
            <p style={pStyle}>{body}</p>
          </div>
        ))}
      </div>
      <div data-rt-card="" style={cardStyle}>
        <span style={{ ...titleStyle, display: "flex", alignItems: "center", gap: 8 }}>
          Sponsored by RapidTunnel
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: "0.12em", color: "#DCF300", border: "1px solid rgba(220,243,0,0.3)", borderRadius: 999, padding: "2px 7px" }}>SPONSOR</span>
        </span>
        <p style={pStyle}>This test is built and hosted by <a href="https://rapidtunnel.com">RapidTunnel</a>, a private VPN. Every RapidTunnel tunnel runs its own encrypted resolver, so lookups ride the same tunnel as your traffic — nothing to intercept, nothing to log.</p>
        <p style={pStyle}>No account, no email. There is <span style={{ color: "#DCF300" }}>no identity to associate your DNS history with</span>. The results above are the same whichever VPN you use.</p>
      </div>
    </div>
  );
}

const cardStyle: React.CSSProperties = { background: "#0A0B0A", border: "1px solid #2A2D29", borderRadius: 26, padding: 24, display: "flex", flexDirection: "column", gap: 10 };
const titleStyle: React.CSSProperties = { fontFamily: "'Sora', sans-serif", fontSize: 15, fontWeight: 700, color: "#DEDFDF" };
const pStyle: React.CSSProperties = { margin: 0, fontSize: 13, lineHeight: 1.7, color: "#8A8D88" };
